import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { useAuth } from 'src/libs/rainbow';
import { QueryOptions } from 'src/libs/react-query';
import { leaderboardKeys } from './leaderboard-keys';
import useGetUserAddress from 'src/hooks/useGetUserAddress';

export interface Response {
  trader_score: number;
  direct_referral_score: number;
  indirect_referral_score: number;
  lp_score: number;
  total_score: number;
  total_vpoint: number;
  rank: number;
  lp_equity: number;
  referral_volume: number;
  trade_volume: number;
  has_claimable_score: boolean;
  lp_referral_score: number;
  referral_lp_equity: number;
}
export interface GetUserScoreParams {
  from?: string;
  to?: string;
}
export const getUserScore = async (params: GetUserScoreParams) => {
  const response = await apiClient.get<Response>(`/v2/leaderboard/score`, {
    params,
  });

  return response.data;
};

export type UseGetAvailableBalanceLPOptions<TData, TError> = QueryOptions<
  Response,
  TError,
  Response,
  ReturnType<typeof leaderboardKeys.getUserScore>
>;

export const useGetUserScore = <TData = Response, TError = Error>(
  params: GetUserScoreParams,
  options?: UseGetAvailableBalanceLPOptions<TData, TError>,
) => {
  const { isAuthenticated, isEthereumWallet } = useAuth();
  const { address } = useGetUserAddress();

  return useQuery({
    queryKey: leaderboardKeys.getUserScore({
      ...params,
      address,
    }),
    queryFn: () => getUserScore(params),
    enabled: isAuthenticated && isEthereumWallet,
    ...options,
  });
};
